"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiValueRemove = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var MultiValueRemove = function MultiValueRemove(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.MultiValueRemove, props, /*#__PURE__*/_react.default.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94978 3.29289C8.55926 2.90237 7.92609 2.90237 7.53557 3.29289L6.12132 4.70714L4.70711 3.29293C4.31658 2.9024 3.68342 2.9024 3.29289 3.29293C2.90237 3.68345 2.90237 4.31662 3.29289 4.70714L4.70711 6.12136L3.29293 7.53553C2.9024 7.92606 2.9024 8.55922 3.29293 8.94975C3.68345 9.34027 4.31662 9.34027 4.70714 8.94975L6.12132 7.53557L7.53553 8.94978C7.92606 9.34031 8.55922 9.34031 8.94975 8.94978C9.34027 8.55926 9.34027 7.92609 8.94975 7.53557L7.53553 6.12136L8.94978 4.70711C9.34031 4.31658 9.34031 3.68342 8.94978 3.29289Z",
    fill: "#4F566B"
  })));
};

exports.MultiValueRemove = MultiValueRemove;